import { Button, Chip, Divider, Grid, Link, Typography } from '@mui/material';
import React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, fontSize } from '@mui/system';

const ErrorToast = ({ title = '', message = '', error = '' }) => {
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify({ title, message, error }));
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item xs={12}>
        <Typography sx={{ mt: '0.5rem', mb: '0.5rem' }} variant="h6">
          {title ? title : 'Oops! Something went wrong!'}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        {message}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            size="small"
            color="secondary"
            variant="contained"
            startIcon={<ContentCopyIcon />}
            sx={{ mt: '0.5rem' }}
            onClick={handleCopyToClipboard}
          >
            Copy Error
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Divider flexItem sx={{ background: 'lightGrey', mt: '1rem', mb: '0.5rem' }} />
        <Grid container justifyContent={'center'}>
          <Typography variant="body2">
            Please report this issue on discord channel{' '}
            <Link
              sx={{ color: 'black', fontSize: '1rem', textDecoration: 'none' }}
              href="https://discord.gg/BXwpNY47"
              target="_blank"
            >
              #help-support
            </Link>
            . <br />
            Copy the error or share a screenshot for reference.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ErrorToast;
